import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaDescriptionFn = /* @__PURE__ */ createRecipe('textarea-description', {}, [])

const textareaDescriptionVariantMap = {}

const textareaDescriptionVariantKeys = Object.keys(textareaDescriptionVariantMap)

export const textareaDescription = /* @__PURE__ */ Object.assign(memo(textareaDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaDescription',
  __getCompoundVariantCss__: textareaDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaDescriptionVariantKeys,
  variantMap: textareaDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaDescriptionVariantKeys)
  },
  getVariantProps: textareaDescriptionFn.getVariantProps,
})